/* Learning Bugs 02.11.26: Rewards without the floating tab + key-facts strip tidy.
   1. Hides Redeemly's floating "Rewards" button (the panel itself stays available) and keeps the panel
      centred vertically on screen when it opens (Redeemly anchors it to where the hidden button would be).
   2. Any element with data-lb-rewards-open opens the Redeemly panel (join / log in / see credit).
   3. Product pages: Redeemly's own "Earn £x in rewards" line is hidden and the rewards become an item in the
      key-facts strip (same style as "Suitable from"), with a chevron at the right edge. Whole item opens the panel.
        CLICK HERE TO JOIN OR LOG IN          ›     (CLICK HERE TO SEE YOUR REWARDS when logged in)
        Earn £x in rewards
        Create a free account to earn 5% on every order   (You earn 5% on every order when logged in)
   4. The delivery estimate box (.lbp-eta) moves into the same strip:
        DELIVERY / Thu 5 – Mon 9 Nov / Express available (small, only where that product offers express)
   5. Strip order on every product page: rewards, age (and any other key facts), delivery, then any
      "Build your own ..." style link items. Variant picker sits above the strip, directly under the price.
   6. If a product has no age fact but its subtitle says "Ages 2 to 5" / "Ages 5 and Over" / "Ages 3+",
      a Suitable from row is made from that.
   7. Look: plain rows on the page background with thin dividers (no card fill), compact text. */
(function () {
  var LAUNCHER_CSS = '.launcher__floating-button{display:none!important}' +
    '.launcher__content-container--desktop{top:50%!important;bottom:auto!important;right:24px!important;transform:translateY(-50%)!important;max-height:min(600px,calc(100vh - 48px))!important}';
  function hideFloatingButton() {
    var host = document.getElementById('mcb-launcher-widget-root');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.getElementById('lb-hide-launcher')) {
      var s = document.createElement('style');
      s.id = 'lb-hide-launcher';
      s.textContent = LAUNCHER_CSS;
      host.shadowRoot.appendChild(s);
    }
    return true;
  }
  if (!hideFloatingButton()) {
    var mo = new MutationObserver(function () { if (hideFloatingButton()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  function openPanel() {
    if (window.redeemly && window.redeemly.launcher && typeof window.redeemly.launcher.open === 'function') {
      window.redeemly.launcher.open();
    } else {
      location.href = '/account';
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lb-rewards-open]');
    if (t) { e.preventDefault(); openPanel(); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-lb-rewards-open]')) { e.preventDefault(); openPanel(); }
  });

  var CSS = '#mcb__rewards-on-pdp-widget__root{display:none!important}' +
    '.lbp-facts.lb-facts--rules{grid-template-columns:minmax(0,1fr);row-gap:0;padding:10px 0}' +
    '.lbp-facts.lb-facts--rules>li{grid-column:1/-1;padding:8px 0;gap:9px}' +
    '.lbp-facts.lb-facts--rules>li+li{border-top:1px solid #E6E8E3}' +
    '.lbp-facts.lb-facts--rules>li:first-child{padding-top:0}' +
    '.lbp-facts.lb-facts--rules>li:last-child{padding-bottom:0}' +
    '.lbp-facts.lb-facts--rules>li .lbp-ico{width:18px;height:18px}' +
    '.lbp-facts.lb-facts--rules small{font-size:9.5px}' +
    '.lbp-facts.lb-facts--rules b{font-size:14px;line-height:1.3}' +
    '.lbp-facts .lb-rwfact{position:relative;cursor:pointer;padding-right:34px!important}' +
    '.lbp-facts .lb-rwfact:focus-visible{outline:2px solid #5E7160;outline-offset:2px;border-radius:8px}' +
    '.lbp-facts .lb-rwfact small{color:#4A6741;font-weight:700}' +
    '.lbp-facts .lb-rwfact:hover small{text-decoration:underline;text-underline-offset:3px}' +
    '.lbp-facts .lb-rwfact .lbp-ico{color:#4A6741}' +
    '.lbp-facts .lb-rwfact .lb-rwfact__go{position:absolute;right:2px;top:50%;width:20px;height:20px;margin-top:-10px;display:grid;place-items:center;border-radius:50%;background:#E4EBE1;color:#3C5635;transition:background .2s,color .2s}' +
    '.lbp-facts.lb-facts--rules .lb-rwfact:first-child .lb-rwfact__go{margin-top:-14px}' +
    '.lbp-facts .lb-rwfact .lb-rwfact__go svg{width:11px;height:11px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}' +
    '.lbp-facts .lb-rwfact:hover .lb-rwfact__go{background:#4A6741;color:#fff}' +
    ".lbp-facts .lb-rwfact em,.lbp-facts .lb-etafact em{display:block;font-style:normal;font:400 11.5px/1.35 'Nunito Sans',system-ui,-apple-system,'Segoe UI',sans-serif;color:#6E6B66;margin-top:1px}" +
    '.input-row.lb-picker-top{margin:6px 0 2px}' +
    '.lbp-eta.lb-eta-moved{display:none!important}';

  var GIFT = '<svg class="lbp-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 11.5h17v9h-17zM3 7.5h18v4H3zM12 7.5v13M12 7.5c-1.5-3.5-5-4-5-1.5s3.5 1.5 5 1.5zm0 0c1.5-3.5 5-4 5-1.5s-3.5 1.5-5 1.5z"/></svg>';
  var TRUCK = '<svg class="lbp-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 6.5h11v9H3zM14 9.5h3.6l3.4 3.4v2.6h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var PERSON = '<svg class="lbp-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="7" r="3"></circle><path d="M6 20c0-3.5 2.7-6 6-6s6 2.5 6 6"></path></svg>';
  var GO = '<span class="lb-rwfact__go" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></span>';

  function amount() {
    var root = document.getElementById('mcb__rewards-on-pdp-widget__root');
    if (!root) return null;
    var m = root.textContent.match(/£\s?\d[\d,]*(?:\.\d{2})?/);
    return m ? m[0].replace(/\s/g, '') : null;
  }
  function anchorAfterPrice() {
    var price = document.querySelector('.price-container');
    if (!price) return null;
    var n = price.nextElementSibling;
    return (n && /redeemly/i.test(n.innerHTML)) ? n : price;
  }
  function factsList() {
    var ul = document.querySelector('.lbp-facts');
    if (!ul) {
      var after = anchorAfterPrice();
      if (!after) return null;
      var row = document.createElement('div');
      row.className = 'lightly-spaced-row lbp-facts-row';
      row.innerHTML = '<div class="lbp-facts-wrap"><ul class="lbp-facts"></ul></div>';
      after.after(row);
      ul = row.querySelector('.lbp-facts');
    }
    ul.classList.add('lb-facts--rules');
    return ul;
  }
  function ensureCss() {
    if (document.getElementById('lb-rw-css')) return;
    var css = document.createElement('style'); css.id = 'lb-rw-css'; css.textContent = CSS; document.head.appendChild(css);
  }
  function isLinkItem(li) { return !li.classList.contains('lb-rwfact') && !li.classList.contains('lb-etafact') && !!li.querySelector('a'); }
  function hasAge(ul) { return [].some.call(ul.children, function (li) { return /suitable from/i.test(li.textContent); }); }
  function ageFromSubtitle() {
    var el = document.querySelector('.lbp-tagline');
    if (!el) return null;
    var t = el.textContent;
    var m = t.match(/\bages?\s+(\d+)\s*(?:to|-|–)\s*(\d+)\b/i);
    if (m) return m[1] + ' to ' + m[2] + ' Years';
    m = t.match(/\bages?\s+(\d+)\s*(?:\+|and\s+(?:over|up|above))/i);
    if (m) return m[1] + ' Years+';
    m = t.match(/\b(\d+)\s*months?\s*(?:\+|and\s+(?:over|up))/i);
    if (m) return m[1] + ' Months+';
    return null;
  }
  function placeAge(ul) {
    if (hasAge(ul) || ul.querySelector('.lb-agefact')) return;
    var age = ageFromSubtitle();
    if (!age) return;
    var li = document.createElement('li');
    li.className = 'lb-agefact';
    li.innerHTML = PERSON + ' <span><small>Suitable from</small><b>' + age + '</b></span>';
    ul.appendChild(li);
  }
  function sortStrip(ul) {
    var items = [].slice.call(ul.children);
    var rw = items.filter(function (li) { return li.classList.contains('lb-rwfact'); });
    var eta = items.filter(function (li) { return li.classList.contains('lb-etafact'); });
    var links = items.filter(isLinkItem);
    var facts = items.filter(function (li) { return rw.indexOf(li) < 0 && eta.indexOf(li) < 0 && links.indexOf(li) < 0; });
    rw.concat(facts, eta, links).forEach(function (li) { ul.appendChild(li); });
  }
  function placeRewards() {
    document.querySelectorAll('.lb-rewards-link, .lb-rw--row, .lb-rw, .lb-rwtag').forEach(function (p) { (p.closest('.lightly-spaced-row.not-in-quickbuy') || p).remove(); });
    var amt = amount();
    var item = document.querySelector('.lb-rwfact');
    if (!amt) { if (item) item.remove(); return; }
    var ul = factsList();
    if (!ul) return;
    var logged = !!(window.__st && window.__st.cid);
    var label = logged ? 'Click here to see your rewards' : 'Click here to join or log in';
    var note = logged ? 'You earn 5% on every order' : 'Create a free account to earn 5% on every order';
    if (!item) {
      item = document.createElement('li');
      item.className = 'lb-rwfact';
      item.setAttribute('data-lb-rewards-open', '');
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      ul.insertBefore(item, ul.firstChild);
    }
    item.setAttribute('aria-label', label + '. Earn ' + amt + ' in rewards on this order. ' + note);
    item.innerHTML = GIFT + ' <span><small>' + label + '</small><b>Earn ' + amt + ' in rewards</b><em>' + note + '</em></span>' + GO;
  }
  function placeDelivery() {
    var eta = document.querySelector('.lbp-eta');
    if (!eta || eta.classList.contains('lb-eta-moved')) return;
    var t = eta.querySelector('.lbp-eta__t');
    if (!t) return;
    var ul = factsList();
    if (!ul) return;
    var title = t.textContent.replace(/\s+/g, ' ').trim();
    var kind = eta.getAttribute('data-kind') || '';
    var label = 'Delivery';
    var head = title.replace(/^Arrives\s+/i, '');
    if (kind === 'made') { label = 'Made to order'; head = title.replace(/^Made to order\s*·\s*arrives\s*(in\s*)?/i, 'Arrives '); }
    if (kind === 'preorder') { label = 'Pre-order'; head = 'Dispatched within 2 weeks'; }
    var li = document.createElement('li');
    li.className = 'lb-etafact';
    li.innerHTML = TRUCK + ' <span><small>' + label + '</small><b>' + head + '</b>' + (kind === 'express' ? '<em>Express available</em>' : '') + '</span>';
    ul.appendChild(li);
    eta.classList.add('lb-eta-moved');
  }
  function placePicker() {
    var vp = document.querySelector('.product-info variant-picker, .product-column-right variant-picker');
    if (!vp) return;
    var row = vp.closest('.input-row');
    if (!row || row.classList.contains('lb-picker-top')) return;
    if (!vp.querySelector('.option-selector, .variant-picker__option, select, input')) return;
    var after = anchorAfterPrice();
    if (!after) return;
    row.classList.add('lb-picker-top');
    after.after(row);
  }
  function place() {
    if (!document.body.classList.contains('template-product')) return;
    ensureCss();
    placePicker();
    placeRewards();
    placeDelivery();
    var ul = document.querySelector('.lbp-facts');
    if (ul) { placeAge(ul); sortStrip(ul); }
  }
  function start() {
    place();
    var root = document.getElementById('mcb__rewards-on-pdp-widget__root');
    if (root) new MutationObserver(function () { placeRewards(); }).observe(root, { childList: true, subtree: true, characterData: true });
    setTimeout(place, 1500);
    setTimeout(place, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
